import { UserModel } from '$store/models';
import { Person, WithContext } from 'schema-dts';
import { useMemo } from 'react';
import { useUnitName } from '$hooks/useUnitName';
import { format, parse } from 'date-fns';

export const usePersonSchema = (user: UserModel): WithContext<Person> => {
  const userName = useUnitName(user);

  const canonical = useMemo(() => {
    if (user) {
      return `https://${location.hostname}/${
        user?.domain ? user.domain : `id${user?.id}`
      }`;
    } else {
      return '';
    }
  }, [user]);

  const bDateISO = useMemo(() => {
    if (user?.bDate) {
      let matches = user.bDate.match(/(\d+).(\d+).(\d+)/) || [];
      if (+matches[1] > 0 && +matches[2] > 0 && +matches[3] > 0) {
        const date = parse(user.bDate, 'dd.MM.yyyy', new Date());
        return format(date, 'yyyy-MM-dd');
      } else if (+matches[1] > 0 && +matches[2] > 0) {
        const date = parse(`${matches[1]}.${matches[2]}`, 'dd.MM', new Date());
        return format(date, 'yyyy-MM-dd');
      }
      return;
    }
  }, [user]);

  return user
    ? {
        '@context': 'https://schema.org',
        '@type': 'Person',
        '@id': 'id' + user.id,
        url: canonical,
        name: userName,
        description: user.bio?.replace('\n', ' '),
        disambiguatingDescription: user.status,
        additionalName: user.domain,
        jobTitle: user.verified === 2 ? 'Model' : undefined,
        awards: [
          user.hasNftPhoto && 'NFT Avatar',
          user.verified && 'Verified profile',
        ].filter(Boolean) as string[],
        gender: user.sex === 1 ? 'Female' : 'Male',
        image: user?.photoLarge,
        birthDate: bDateISO,
        affiliation: [
          {
            '@type': 'Organization',
            name: 'Ton.Place',
          },
        ],
      }
    : {
        '@context': 'https://schema.org',
        '@type': 'Person',
      };
};
